import { Box, Icon, Typography } from "@drone-js/core";
import { HStack, VStack } from "apps/commons/components/Stack";
import type { PropertyData } from "libs/codegen/property-onboarding";
import { useWatch } from "react-hook-form";
import { PropertyImage } from "../photos/photo/PropertyImage";

export const PropertyOverview = () => {
    const propertyPhoto = useWatch<PropertyData>({
        name: "photos.0.src",
    }) as string;
    const propertyName = useWatch<PropertyData>({
        name: "propertyName",
    }) as string;
    const stateName = useWatch<PropertyData>({
        name: "state.name",
    }) as string;
    const cityName = useWatch<PropertyData>({
        name: "city.name",
    }) as string;

    return (
        <HStack gap="16" alignItems="center">
            <Box
                width="64px"
                height="64px"
                borderRadius="4"
                overflow="hidden"
                backgroundColor="base.inset"
                position="relative"
            >
                <PropertyImage src={propertyPhoto} />
            </Box>
            <VStack gap="8">
                <Typography variant="body-default-strong" lineClamp={2}>
                    {propertyName}
                </Typography>
                <HStack gap="4">
                    <Icon id="fill.symbol.pin" size="14" color="base.subtle" />
                    <Typography variant="body-s" textColor="base.subtle">
                        {cityName}, {stateName}
                    </Typography>
                </HStack>
            </VStack>
        </HStack>
    );
};
